import React from "react";
import { ACADEMY_IMAGES } from "../../pages/careersMedia";

export const ACADEMY_META = {
  driver: { label: "Field operations" },
  operations: { label: "Dispatch & control" },
  leadership: { label: "People & teams" },
  business: { label: "Growth & finance" },
  customer: { label: "Service excellence" },
};

export const ACADEMY_CATALOG = [
  {
    slug: "driver",
    title: "Driver Program",
    kicker: "Field operations",
    purpose:
      "Train for safe, profitable last-mile and local delivery work on QikTruck and with partner fleets across South Africa.",
  },
  {
    slug: "operations",
    title: "Operations Program",
    kicker: "Dispatch & control",
    purpose:
      "Learn dispatch, job coordination, and customer communication for high-volume logistics control rooms.",
  },
  {
    slug: "leadership",
    title: "Leadership Program",
    kicker: "People & teams",
    purpose:
      "Develop supervisors and fleet managers who improve team performance, safety, and margin.",
  },
  {
    slug: "business",
    title: "Business Program",
    kicker: "Growth & finance",
    purpose:
      "Build the finance, sales, and compliance foundations for a scalable transport or logistics business.",
  },
  {
    slug: "customer",
    title: "Customer Program",
    kicker: "Service excellence",
    purpose:
      "Help businesses that ship goods book, track, and receive deliveries with fewer failures and disputes.",
  },
];

export function getAcademyMeta(slug) {
  return ACADEMY_META[slug] || { label: "Career program" };
}

export function getAcademyImage(slug) {
  return (
    ACADEMY_IMAGES[slug] || {
      src: ACADEMY_IMAGES.driver.src,
      alt: "QikTruck career program",
      objectPosition: "center center",
    }
  );
}

export function AcademySlugImage({ slug, className = "", loading = "lazy" }) {
  const image = getAcademyImage(slug);
  return (
    <img
      src={image.src}
      alt={image.alt}
      className={className}
      loading={loading}
      width={640}
      height={400}
      style={{ objectPosition: image.objectPosition }}
    />
  );
}
